import styled from 'styled-components';
import { Form } from '@unform/web';

// import * as colors from '~/config/colors';

export const Wrapper = styled.div`
  display: flex;
`;

export const FormWrapper = styled(Form)`
  width: 56rem;
  flex: 1;
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 1rem;
  }

  p.Mui-error {
    margin: 0rem;
  }

`;




export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0 0 0;
  margin: 1rem;
  width: 100%;
  align-content: center;
  align-self: center;

  button {
    margin-top: 1rem;
  }




`;
